import type { CSSProperties } from 'react';
import styles from './Shimmer.module.css';

interface IShimmerProps {
  /** Sizing/shape for this particular block — every skeleton supplies its own. */
  className?: string;
  /** Seconds to delay this block's pulse, so a group waves instead of blinking together. */
  wave?: number;
  style?: CSSProperties;
}

/**
 * One shimmering placeholder block — the primitive every Productivity skeleton is
 * assembled from. Lives in `shared/` because both the page-level skeletons and the
 * Breakdown table's own skeleton need it; keeping it in either one would force the
 * other to reach across folders for it.
 */
export function Shimmer({ className, wave, style }: IShimmerProps) {
  const merged = {
    ...style,
    ...(wave ? ({ ['--wave']: `${wave}s` } as CSSProperties) : {}),
  } as CSSProperties;
  return <span className={`${styles.shimmer} ${className ?? ''}`} style={merged} />;
}
